import axios from "axios";

const KEY = "exotik_admin_token";
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const getToken = () => sessionStorage.getItem(KEY);
export const setToken = (t) => sessionStorage.setItem(KEY, t);
export const clearToken = () => sessionStorage.removeItem(KEY);

export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            clearToken();
            if (!window.location.pathname.endsWith("/admin/login")) {
                window.location.replace("/admin/login");
            }
        }
        return Promise.reject(err);
    },
);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Une erreur s'est produite. Réessayez.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
